<template>
  <div class="zendesk-wrapper">
    <a :href="zendeskLineAccountURL"
      ><img
        src="https://scdn.line-apps.com/n/line_add_friends/btn/en.png"
        alt="Add friend"
        height="36"
    /></a>
  </div>
</template>
<script>
import { config } from "../helpers/domain-config";
import { getDomainTheme } from "../utils/domains-theme";

export default {
  data() {
    const themeConfig = getDomainTheme(config.productName)[config.subdomain];
    return {
      zendeskLineAccountURL: themeConfig
        ? themeConfig.zendeskLineAccountURL
        : null,
    };
  },
};
</script>
<style lang="scss">
.zendesk-wrapper {
  position: fixed;
  bottom: 26px;
  left: 100px;
}
@media screen and (max-width: 640px) {
  .zendesk-wrapper {
    left: 16px;
    bottom: 12px;
  }
}
</style>
